import { useTheme } from 'styled-components';

export const PlusIcon = ({ color }: { color?: string }) => {
  const theme: any = useTheme();
  const strokeColor = color ? `stroke-${color}` : `stroke-${theme.current}-primary`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g id="icon_plus-16" transform="translate(16) rotate(90)">
        <rect
          id="Rectangle_293"
          data-name="Rectangle 293"
          width="16"
          height="16"
          fill="rgba(214,84,84,0)"
        />
        <path
          id="Shape"
          d="M0,0V14"
          transform="translate(8 1)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          className={strokeColor}
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M14,0H0"
          transform="translate(1 8)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          className={strokeColor}
        />
      </g>
    </svg>
  );
};
